import { useMutation, useQueryClient } from "@tanstack/react-query";
import { RemindersKeys } from "web_myplann/Api/Reminders/RemindersKeys";
import { addReminderToListCache } from "web_myplann/Api/Reminders/remindersCacheUtils";
import {
	postPropertyPropertyIdRemindersV2,
	type ReminderResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";
import type { ReminderFormModel } from "web_myplann/Reminders/Forms/reminderFormSchema";
import { mapReminderFormToCreateRequest } from "web_myplann/Reminders/Mappers/mapReminderToRequest";

type CreateReminderVariables = { propertyId: number; model: ReminderFormModel };

export const usePropertyReminderCreateMutation = () => {
	const queryClient = useQueryClient();

	return useMutation<ReminderResponseDTO, Error, CreateReminderVariables>({
		mutationFn: processResponse(
			({ propertyId, model }: CreateReminderVariables) =>
				postPropertyPropertyIdRemindersV2(
					mapReminderFormToCreateRequest(model),
					propertyId,
				),
		),
		onSuccess: (reminder, { propertyId }) => {
			addReminderToListCache(
				queryClient,
				RemindersKeys.propertyList(propertyId),
				reminder,
			);
		},
	});
};
